import { defineMessages } from 'react-intl';

export default defineMessages({
	teamPlan: {
		id: 'paymentOverview.enterprisePlan',
		defaultMessage: 'Calm For Organizations',
		description: 'The plan that the customer is purchasing.',
	},
	individuals: {
		id: 'paymentOverview.individuals',
		defaultMessage: '{selectedCoveredLives} Individuals',
		description: 'The number of covered lives included in the plan.',
	},
	subtotal: {
		id: 'paymentOverview.subtotal',
		defaultMessage: 'Subtotal',
		description: 'The subtotal of the order.',
	},
	discount: {
		id: 'paymentOverview.discount',
		defaultMessage: 'Discount',
		description: 'Discount amount for the order.',
	},
	tax: {
		id: 'paymentOverview.tax',
		defaultMessage: 'Tax',
		description: 'Tax amount for the order.',
	},
	taxTooltip: {
		id: 'paymentOverview.taxTooltip',
		defaultMessage:
			'Please provide your VAT number in the payment form, if applicable. This will ensure correct tax treatment on your future charges and orders.',
		description: 'Tooltip explaining the tax treatment on future charges and orders.',
	},
	enterBillingDetails: {
		id: 'paymentOverview.enterBillingDetails',
		defaultMessage: 'Enter billing details',
		description: 'Placeholder before tax is calculated',
	},
	calculatingTaxes: {
		id: 'paymentOverview.calculatingTaxes',
		defaultMessage: 'Calculating...',
		description: 'Text displayed when the tax amount is being calculated.',
	},
	totalPerYear: {
		id: 'paymentOverview.totalPerYear',
		defaultMessage: 'Total / year',
		description: 'The total cost per year for the plan.',
	},
	edit: {
		id: 'paymentOverview.edit',
		defaultMessage: 'Edit',
		description:
			'Text of a link that will take the user back to the page where they can change the number of covered lives they are purchasing.',
	},
});
